import type { NsDict } from '../ru';

export const verify: NsDict<'verify'> = {
  title: 'Spielprüfung',
  chooseFile: 'Paketdatei wählen…',
  hintBefore: 'Die Prüfung läuft in Ihrem Browser mit demselben offenen Code wie das Kommandozeilenwerkzeug ',
  hintAfter: '. Der Server ist daran nicht beteiligt, außer dass er seinen öffentlichen Schlüssel bereitstellt.',
  notJson: 'Die Datei ist kein JSON-Prüfpaket',
  httpError: 'Fehler {status}',
  metaGame: 'Spiel',
  metaComposition: 'Zusammensetzung',
  metaP0: 'P₀-Bar (UTC)',
  metaSource: 'Quelle',
  sourceSynthetic: 'synthetische Daten — keine echten Kurse',
  sourceAlpaca: 'Alpaca Market Data API v2, Minutenbars, Feed {feed}',
  busy: 'Neuberechnung…',
  exportHint: 'Exporte zum Abgleich mit externen Kursquellen (UTC, Trennzeichen „;“):',
  exportQuotes: 'Aktienkurse, CSV',
  exportIndex: 'Index-Bars, CSV',
  exportActions: 'Aktionsprotokoll, CSV',
  exportPackage: 'Paket, JSON',
  // ── заголовки проверок ──
  'check.title.format': 'Dateiformat',
  'check.title.signature': 'Serversignatur (Ed25519)',
  'check.title.commitment': 'Commitment: Zusammensetzung vor den Einsätzen festgelegt',
  'check.title.aggregate': 'Index-Bars aus Aktienkursen neu berechnet',
  'check.title.prices': 'P₀, P₁ und Änderung Δ',
  'check.title.timeline': 'Ablauf: Aktionen vor der Fixierung, Aufdeckungen nach Phasen',
  'check.title.contributions': 'Beiträge der Spieler stimmen mit den Buchungen überein',
  'check.title.settlement': 'Auszahlungen vollständig neu berechnet',
  'check.title.ledger': 'Credit-Buchungen gehen auf',
  // ── итог ──
  'check.summary.unrecognized': 'Datei nicht erkannt',
  'check.summary.ok': 'Alle Prüfungen bestanden ({ok} von {total}).',
  'check.summary.okWarn': 'Alle Prüfungen bestanden ({ok} von {total}, mit Anmerkungen).',
  'check.summary.fail': 'Nicht bestanden: {titles}.',
  'check.format.notPackage': 'dies ist kein Prüfpaket von Market Table',
  // ── подпись ──
  'check.signature.missing': 'Signatur fehlt oder unbekannter Algorithmus',
  'check.signature.keyMismatch': 'der Schlüssel in der Datei stimmt nicht mit dem veröffentlichten Serverschlüssel überein',
  'check.signature.keyTrusted': 'Schlüssel {keyId} stimmt mit dem vom Server veröffentlichten überein',
  'check.signature.keyUntrusted': 'Schlüssel {keyId} (vergleichen Sie mit /api/verification-key)',
  'check.signature.intact': 'der Paketinhalt wurde seit der Ausgabe nicht verändert',
  'check.signature.invalid': 'die Signatur passt nicht zum Inhalt — die Datei wurde verändert',
  'check.signature.error': 'Fehler bei der Signaturprüfung: {error}',
  // ── обязательство ──
  'check.commitment.hashOk': 'SHA-256(Salt:Parameter) = {hash}… stimmt mit dem veröffentlichten Hash überein',
  'check.commitment.hashMismatch': 'Hash stimmt nicht überein: berechnet {computed}, veröffentlicht {published}',
  'check.commitment.badJson': 'die Parameter des Commitments sind kein gültiges JSON',
  'check.commitment.symbolsMismatch': 'Zusammensetzung im Commitment {committed} ≠ aufgedeckte {revealed}',
  'check.commitment.symbols': 'Zusammensetzung im Commitment: {symbols}',
  'check.commitment.basePricesMismatch': 'die Basispreise im Commitment weichen von den aufgedeckten ab',
  'check.commitment.basePricesOk': 'Basispreise stimmen überein',
  'check.commitment.p0Mismatch': 'die Zeit des P₀-Bars im Commitment stimmt nicht überein',
  'check.commitment.formulaMismatch': 'Formel/Basis/Tick im Commitment weichen von den angewandten ab',
  'check.commitment.sessionMismatch': 'die Sitzungs-ID im Commitment stimmt nicht überein',
  // ── бары индекса ──
  'check.aggregate.barMismatch': 'Bar k={k} ({time}): {fields}',
  'check.aggregate.field': '{field}: angezeigt {shown}, neu berechnet {recomputed}',
  'check.aggregate.unknownFormula': 'Formel {formula} ist dieser Prüfversion unbekannt oder passt nicht zu {n} {n:Komponente|Komponenten}',
  'check.aggregate.ok': '{n} {n:Bar stimmt|Bars stimmen} mit der Neuberechnung nach Formel {formula} überein',
  'check.aggregate.source': 'Kursquelle: {source}',
  // ── цены ──
  'check.prices.p0Mismatch': 'P₀ muss {base} sein: neu berechnet {recomputed}, in der Abrechnung {settled}',
  'check.prices.p0': 'P₀ = {p0|num} (Schluss des Bars {time})',
  'check.prices.noTarget': 'keine Zielkerze zur Neuberechnung von P₁',
  'check.prices.p1Mismatch': 'P₁: in der Abrechnung {settled}, neu berechnet {recomputed}',
  'check.prices.deltaMismatch': 'Δ in Ticks: in der Abrechnung {settled}, neu berechnet {recomputed}',
  'check.prices.p1': 'P₁ = {p1|num} (Schluss der Zielminute {time}), Δ = {sign}{delta|num}',
  'check.prices.notNeeded': 'Ausgang „{kind}“ — P₁ wurde für die Abrechnung nicht benötigt',
  // ── хронология ──
  'check.timeline.late': 'Aktionen nach der Fixierung: {actions}',
  'check.timeline.allBefore': 'alle Aktionen ({n}) vor der Fixierung der Prognosen um {time}',
  'check.timeline.compositionEarly': 'Zusammensetzung vor Beginn von Runde 3 aufgedeckt',
  'check.timeline.compositionOk': 'Zusammensetzung um {time} aufgedeckt — mit Beginn von Runde 3',
  'check.timeline.viewerLate': 'Änderungen Ihrer Prognose nach der Fixierung: {n}',
  'check.timeline.viewerOk': 'Ihre Prognose wurde {n}-mal geändert, alle Änderungen vor der Fixierung',
  'check.timeline.finalMismatch': 'die endgültige Prognose in der Abrechnung weicht von Ihrer letzten Änderung ab',
  'check.timeline.unordered': 'das Aktionsprotokoll ist nicht geordnet',
  // ── вклады ──
  'check.contributions.mismatch': '{name}: laut Buchungen Ante {ante|cr}, Runden {rounds|cr}; in der Abrechnung Ante {settledAnte|cr}, Runden {settledRounds|cr}',
  'check.contributions.ok': 'bei {n} {n:Teilnehmer|Teilnehmern} stimmen Antes und Einsätze je Runde mit den Buchungen überein',
  // ── расчёт ──
  'check.settlement.error': 'Neuberechnung fehlgeschlagen: {error}',
  'check.settlement.statusMismatch': 'Status: im Paket „{settled}“, neu berechnet „{recomputed}“',
  'check.settlement.noPlayer': 'Spieler {playerId} fehlt in der Abrechnung',
  'check.settlement.playerMismatch': '{name}: Auszahlung {payout|cr} / Rückerstattung {refund|cr} im Paket, neu berechnet {rePayout|cr} / {reRefund|cr}',
  'check.settlement.commissionMismatch': 'Kommission je Runde: im Paket {settled}, neu berechnet {recomputed}',
  'check.settlement.bankMismatch': 'auf das Hauskonto einbehalten: im Paket {settled|cr}, neu berechnet {recomputed|cr}',
  'check.settlement.unbalanced': 'die neu berechnete Abrechnung geht nicht auf',
  'check.settlement.outcome': 'Ausgang: {kind}',
  'check.settlement.outcomeReason': 'Ausgang: {kind} ({reason})',
  'check.settlement.kind.market': 'nach Markt',
  'check.settlement.kind.walkover': 'ein Teilnehmer übrig',
  'check.settlement.kind.cancel': 'Abbruch',
  'check.settlement.totals': 'Pots: {pots}; Kommission je Runde {commission|cr}; einbehalten {withheld|cr}',
  'check.settlement.payout': '{name}: Auszahlung {payout|cr}',
  'check.settlement.payoutError': '{name}: Auszahlung {payout|cr}, Prognosefehler {error|num} Pkt.',
  'check.settlement.wrongDirection': 'Auszahlung an einen Spieler mit falscher Richtung',
  // ── проводки ──
  'check.ledger.escrowNonZero': 'Saldo des Spielkontos: {net|cr} (muss 0 sein)',
  'check.ledger.escrowZero': 'Spielkonto mit null abgeschlossen',
  'check.ledger.playerMismatch': '{name}: gebuchte Auszahlungen {payout|cr} / Rückerstattungen {refund|cr}, in der Abrechnung {settledPayout|cr} / {settledRefund|cr}',
  'check.ledger.commissionMismatch': 'Kommission in den Buchungen {ledger|cr}, in der Abrechnung {settled|cr}',
  'check.ledger.ok': 'abgebucht {debited|cr} = ausgezahlt {paid|cr} + erstattet {refunded|cr} + Hauskonto {bank|cr}',
};
